import { FC, useEffect, useState } from "react";
import { serviceAreas } from "../../services/service-areas";
import { Loading } from "../../components/shared";
import { useTranslation, Trans } from "react-i18next";

type Props = {
  slug: string,
}

const AverageAdditionsPercentForCategoryTooltip: FC<Props> = ({ slug }) => {
  const [t] = useTranslation('projects', { keyPrefix: 'purchaseList.averageAdditionsPercent' });
  const [name, setName] = useState("");
  const [percent, setPercent] = useState("");
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const response = await serviceAreas.getAverageAdditionsPercent(slug);
      setName(response.name);
      setPercent(response.percent);
      setCount(response.count);
      setLoading(false);
    })();
  }, [])

  if (loading) {
    return <div style={{ marginBlock: "1em" }}><Loading loadingStyle="bubbles" type='inline' color="#ff5e15" size='30px' /></div>;
  }

  if (!name) return null;

  return (
    <p>
      <Trans t={t} i18nKey="info" values={{name, percent, count}} components={{percent: <span style={{ fontWeight: "500", color: "var(--gray-900)" }}>{percent}%</span>}} />
    </p>
  );
}

export default AverageAdditionsPercentForCategoryTooltip;
